import {
  toString30pk9tzaqopn as toString,
  protoOf180f3jzyo7rfj as protoOf,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  captureStack1fzi4aczwc4hg as captureStack,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  defineProp3hxgpk2knu2px as defineProp,
  CancellationException3b36o9qz53rgr as CancellationException,
  newThrowablezl37abp36p5f as newThrowable,
  extendThrowable112s72v177bbq as extendThrowable,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  Unit_instance104q5opgivhr8 as Unit_instance,
  isInterface3d6p8outrmvmk as isInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  KtList3hktaavzmj137 as KtList,
  _Result___get_isSuccess__impl__sndoy82z6txcyihce8z as _Result___get_isSuccess__impl__sndoy8,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  Result3t1vadv16kmzk as Result,
  emptyList1g2z5xcrvp2zy as emptyList,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$_0,
  plus20p0vtfmu0596 as plus,
  Unitkvevlwgzwiuc as Unit,
  getKClass1s3j9wy1cofik as getKClass,
  Enum3alwj03lh1n41 as Enum,
} from './kotlin-kotlin-stdlib.mjs';
import {
  FlowCollector26clgpmzihvke as FlowCollector,
  emitAllzzmeew3d68ub as emitAll,
  flow3tazazxj2t7g4 as flow,
  firstOrNull12rzggh6e86lb as firstOrNull,
  Mutex16li1l0asjv17 as Mutex,
  MutableStateFlow34bfoyvwu8czu as MutableStateFlow,
  asStateFlow34rribx643ke5 as asStateFlow,
} from './kotlinx-coroutines-core.mjs';
import {
  ICache3bwileb79diof as ICache,
  emptyIfNull1t7oeph6e4stc as emptyIfNull,
  CacheCleanerRegistry1txtxriyqr3kw as CacheCleanerRegistry,
  ICacheCleaner2xrjdwipcre7v as ICacheCleaner,
  InMemoryCache2v1xems7p2diw as InMemoryCache,
} from './Shared7Punches-infrastructure-cache.mjs';
import {
  toLocalDateTime3u4c8ydzr4ubp as toLocalDateTime,
  System_instance3bcuv0kn0rmcj as System_instance,
  Companion_getInstance2irhlaa79e82g as Companion_getInstance,
} from './Kotlin-DateTime-library-kotlinx-datetime.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_0,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  binds4rk2rn2wwzpn as binds,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(SevenResult, 'SevenResult', VOID, VOID, VOID, [1]);
initMetadataForClass(Success, 'Success', VOID, SevenResult, VOID, [1]);
initMetadataForClass(Failure, 'Failure', VOID, SevenResult, VOID, [1]);
initMetadataForCompanion(Companion);
initMetadataForClass(SevenThrowable, 'SevenThrowable', VOID, Error);
initMetadataForClass(Unknown, 'Unknown', Unknown, SevenThrowable);
initMetadataForClass(BadRequest, 'BadRequest', BadRequest, SevenThrowable);
initMetadataForClass(Unauthorized, 'Unauthorized', Unauthorized, SevenThrowable);
initMetadataForClass(Forbidden, 'Forbidden', Forbidden, SevenThrowable);
initMetadataForClass(NotFound, 'NotFound', NotFound, SevenThrowable);
initMetadataForClass(Conflict, 'Conflict', Conflict, SevenThrowable);
initMetadataForClass(UnexpectedApiResponse, 'UnexpectedApiResponse', UnexpectedApiResponse, SevenThrowable);
initMetadataForCompanion(Companion_0);
initMetadataForInterface(ILocalSource, 'ILocalSource', VOID, VOID, VOID, [1, 0]);
initMetadataForInterface(IListLocalSource, 'IListLocalSource', VOID, VOID, [ILocalSource], [1, 2, 0]);
initMetadataForLambda(SessionBasedCache$get$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($putCOROUTINE$5, CoroutineImpl);
initMetadataForClass(SessionBasedCache, 'SessionBasedCache', VOID, VOID, [ICache], [2, 1, 0]);
initMetadataForCoroutine($getSessionBasedKeyCOROUTINE$9, CoroutineImpl);
initMetadataForClass(SimpleCacheLocalSource, 'SimpleCacheLocalSource', VOID, VOID, [ILocalSource], [1, 0]);
initMetadataForClass(SimpleListCacheLocalSource, 'SimpleListCacheLocalSource', VOID, VOID, [IListLocalSource], [1, 0, 2]);
initMetadataForClass(BaseCacheStrategy, 'BaseCacheStrategy');
initMetadataForLambda(GetCacheStrategy$baseCacheStrategy$slambda, CoroutineImpl, VOID, [3]);
initMetadataForClass(GetCacheStrategy, 'GetCacheStrategy');
initMetadataForLambda(GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$11, CoroutineImpl);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(GetFromListCacheStrategy$baseCacheStrategy$1$$inlined$map$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForLambda(GetFromListCacheStrategy$baseCacheStrategy$slambda, CoroutineImpl, VOID, [3]);
initMetadataForClass(GetFromListCacheStrategy, 'GetFromListCacheStrategy');
initMetadataForLambda(ListCacheStrategy$baseCacheStrategy$slambda, CoroutineImpl, VOID, [3]);
initMetadataForClass(ListCacheStrategy, 'ListCacheStrategy');
initMetadataForLambda(QueryListEndpointCacheStrategy$getStrategy$slambda, CoroutineImpl, VOID, [0]);
initMetadataForLambda(QueryListEndpointCacheStrategy$getStrategy$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForClass(QueryListEndpointCacheStrategy, 'QueryListEndpointCacheStrategy');
initMetadataForLambda(SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$12, CoroutineImpl);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(SimpleGetEndpointCacheStrategy$strategy$1$$inlined$map$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForLambda(SimpleGetEndpointCacheStrategy$strategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(SimpleGetEndpointCacheStrategy, 'SimpleGetEndpointCacheStrategy');
initMetadataForLambda(SimpleListEndpointCacheStrategy$getStrategy$slambda, CoroutineImpl, VOID, [0]);
initMetadataForLambda(SimpleListEndpointCacheStrategy$listStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(SimpleListEndpointCacheStrategy$listStrategy$slambda_1, CoroutineImpl, VOID, [2]);
initMetadataForClass(SimpleListEndpointCacheStrategy, 'SimpleListEndpointCacheStrategy');
initMetadataForLambda(SimpleValueEndpointCacheStrategy$baseStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(SimpleValueEndpointCacheStrategy, 'SimpleValueEndpointCacheStrategy');
function emitError$default(error, value, $completion, $super) {
  value = value === VOID ? null : value;
  return $super === VOID ? this.w2x(error, value, $completion) : $super.w2x.call(this, error, value, $completion);
}
initMetadataForInterface(DataStreamCollector, 'DataStreamCollector', VOID, VOID, VOID, [1, 2]);
function getCurrentDate$default(timeZone, $super) {
  timeZone = timeZone === VOID ? Companion_getInstance().s2t() : timeZone;
  return $super === VOID ? this.f37(timeZone) : $super.f37.call(this, timeZone);
}
initMetadataForInterface(IDateTimeProvider, 'IDateTimeProvider');
initMetadataForClass(DateTimeProvider, 'DateTimeProvider', DateTimeProvider, VOID, [IDateTimeProvider]);
initMetadataForInterface(IAppLifecycleProvider, 'IAppLifecycleProvider');
initMetadataForClass(AppLifecycleProvider, 'AppLifecycleProvider', AppLifecycleProvider, VOID, [IAppLifecycleProvider]);
initMetadataForClass(AppLifecycleState, 'AppLifecycleState', VOID, Enum);
initMetadataForInterface(IEnvironmentProvider, 'IEnvironmentProvider');
initMetadataForClass(Platform, 'Platform', VOID, Enum);
initMetadataForInterface(INetworkReachabilityProvider, 'INetworkReachabilityProvider');
initMetadataForClass(NetworkReachabilityState, 'NetworkReachabilityState', VOID, Enum);
initMetadataForInterface(ISessionDataProvider, 'ISessionDataProvider', VOID, VOID, VOID, [0]);
initMetadataForClass(NetworkReachabilityProvider, 'NetworkReachabilityProvider', NetworkReachabilityProvider, VOID, [INetworkReachabilityProvider]);
//endregion
function Success(value) {
  SevenResult.call(this);
  this.x2t_1 = value;
}
protoOf(Success).toString = function () {
  return 'Success(value=' + toString(this.x2t_1) + ')';
};
protoOf(Success).hashCode = function () {
  return this.x2t_1 == null ? 0 : hashCode(this.x2t_1);
};
protoOf(Success).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Success))
    return false;
  var tmp0_other_with_cast = other instanceof Success ? other : THROW_CCE();
  if (!equals(this.x2t_1, tmp0_other_with_cast.x2t_1))
    return false;
  return true;
};
function Failure(exception) {
  SevenResult.call(this);
  this.z2t_1 = exception;
}
protoOf(Failure).toString = function () {
  return 'Failure(exception=' + this.z2t_1.toString() + ')';
};
protoOf(Failure).hashCode = function () {
  return hashCode(this.z2t_1);
};
protoOf(Failure).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Failure))
    return false;
  var tmp0_other_with_cast = other instanceof Failure ? other : THROW_CCE();
  if (!equals(this.z2t_1, tmp0_other_with_cast.z2t_1))
    return false;
  return true;
};
function Companion() {
}
protoOf(Companion).a2u = function (result) {
  // Inline function 'kotlin.fold' call
  var exception = Result__exceptionOrNull_impl_p6xea9(result);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(result);
    var value = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    tmp = new Success(value);
  } else {
    tmp = new Failure(Companion_instance_0.b2u(exception));
  }
  return tmp;
};
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
function SevenResult() {
}
protoOf(SevenResult).y2t = function () {
  var tmp;
  if (this instanceof Success) {
    tmp = this.x2t_1;
  } else {
    if (this instanceof Failure) {
      throw this.z2t_1;
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
};
function toSevenResult(_this__u8e3s4) {
  return Companion_instance.a2u(_this__u8e3s4);
}
function Unknown(cause, message) {
  cause = cause === VOID ? null : cause;
  message = message === VOID ? null : message;
  SevenThrowable.call(this);
  captureStack(this, Unknown);
  this.c2u_1 = cause;
  this.d2u_1 = message;
}
protoOf(Unknown).h1 = function () {
  return this.c2u_1;
};
protoOf(Unknown).g1 = function () {
  return this.d2u_1;
};
protoOf(Unknown).toString = function () {
  return 'Unknown(cause=' + toString(this.c2u_1) + ', message=' + this.d2u_1 + ')';
};
protoOf(Unknown).hashCode = function () {
  var result = this.c2u_1 == null ? 0 : hashCode(this.c2u_1);
  result = imul(result, 31) + (this.d2u_1 == null ? 0 : getStringHashCode(this.d2u_1)) | 0;
  return result;
};
protoOf(Unknown).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Unknown))
    return false;
  var tmp0_other_with_cast = other instanceof Unknown ? other : THROW_CCE();
  if (!equals(this.c2u_1, tmp0_other_with_cast.c2u_1))
    return false;
  if (!(this.d2u_1 == tmp0_other_with_cast.d2u_1))
    return false;
  return true;
};
function BadRequest(message) {
  message = message === VOID ? null : message;
  SevenThrowable.call(this);
  captureStack(this, BadRequest);
  this.e2u_1 = message;
}
protoOf(BadRequest).g1 = function () {
  return this.e2u_1;
};
protoOf(BadRequest).toString = function () {
  return 'BadRequest(message=' + this.e2u_1 + ')';
};
protoOf(BadRequest).hashCode = function () {
  return this.e2u_1 == null ? 0 : getStringHashCode(this.e2u_1);
};
protoOf(BadRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BadRequest))
    return false;
  var tmp0_other_with_cast = other instanceof BadRequest ? other : THROW_CCE();
  if (!(this.e2u_1 == tmp0_other_with_cast.e2u_1))
    return false;
  return true;
};
function Unauthorized(message) {
  message = message === VOID ? null : message;
  SevenThrowable.call(this);
  captureStack(this, Unauthorized);
  this.f2u_1 = message;
}
protoOf(Unauthorized).g1 = function () {
  return this.f2u_1;
};
protoOf(Unauthorized).toString = function () {
  return 'Unauthorized(message=' + this.f2u_1 + ')';
};
protoOf(Unauthorized).hashCode = function () {
  return this.f2u_1 == null ? 0 : getStringHashCode(this.f2u_1);
};
protoOf(Unauthorized).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Unauthorized))
    return false;
  var tmp0_other_with_cast = other instanceof Unauthorized ? other : THROW_CCE();
  if (!(this.f2u_1 == tmp0_other_with_cast.f2u_1))
    return false;
  return true;
};
function Forbidden(message) {
  message = message === VOID ? null : message;
  SevenThrowable.call(this);
  captureStack(this, Forbidden);
  this.g2u_1 = message;
}
protoOf(Forbidden).g1 = function () {
  return this.g2u_1;
};
protoOf(Forbidden).toString = function () {
  return 'Forbidden(message=' + this.g2u_1 + ')';
};
protoOf(Forbidden).hashCode = function () {
  return this.g2u_1 == null ? 0 : getStringHashCode(this.g2u_1);
};
protoOf(Forbidden).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Forbidden))
    return false;
  var tmp0_other_with_cast = other instanceof Forbidden ? other : THROW_CCE();
  if (!(this.g2u_1 == tmp0_other_with_cast.g2u_1))
    return false;
  return true;
};
function NotFound(message) {
  message = message === VOID ? null : message;
  SevenThrowable.call(this);
  captureStack(this, NotFound);
  this.h2u_1 = message;
}
protoOf(NotFound).g1 = function () {
  return this.h2u_1;
};
protoOf(NotFound).toString = function () {
  return 'NotFound(message=' + this.h2u_1 + ')';
};
protoOf(NotFound).hashCode = function () {
  return this.h2u_1 == null ? 0 : getStringHashCode(this.h2u_1);
};
protoOf(NotFound).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NotFound))
    return false;
  var tmp0_other_with_cast = other instanceof NotFound ? other : THROW_CCE();
  if (!(this.h2u_1 == tmp0_other_with_cast.h2u_1))
    return false;
  return true;
};
function Conflict(message) {
  message = message === VOID ? null : message;
  SevenThrowable.call(this);
  captureStack(this, Conflict);
  this.i2u_1 = message;
}
protoOf(Conflict).g1 = function () {
  return this.i2u_1;
};
protoOf(Conflict).toString = function () {
  return 'Conflict(message=' + this.i2u_1 + ')';
};
protoOf(Conflict).hashCode = function () {
  return this.i2u_1 == null ? 0 : getStringHashCode(this.i2u_1);
};
protoOf(Conflict).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Conflict))
    return false;
  var tmp0_other_with_cast = other instanceof Conflict ? other : THROW_CCE();
  if (!(this.i2u_1 == tmp0_other_with_cast.i2u_1))
    return false;
  return true;
};
function UnexpectedApiResponse(cause, message) {
  cause = cause === VOID ? null : cause;
  message = message === VOID ? null : message;
  SevenThrowable.call(this);
  captureStack(this, UnexpectedApiResponse);
  this.j2u_1 = cause;
  this.k2u_1 = message;
}
protoOf(UnexpectedApiResponse).h1 = function () {
  return this.j2u_1;
};
protoOf(UnexpectedApiResponse).g1 = function () {
  return this.k2u_1;
};
protoOf(UnexpectedApiResponse).toString = function () {
  return 'UnexpectedApiResponse(cause=' + toString(this.j2u_1) + ', message=' + this.k2u_1 + ')';
};
protoOf(UnexpectedApiResponse).hashCode = function () {
  var result = this.j2u_1 == null ? 0 : hashCode(this.j2u_1);
  result = imul(result, 31) + (this.k2u_1 == null ? 0 : getStringHashCode(this.k2u_1)) | 0;
  return result;
};
protoOf(UnexpectedApiResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UnexpectedApiResponse))
    return false;
  var tmp0_other_with_cast = other instanceof UnexpectedApiResponse ? other : THROW_CCE();
  if (!equals(this.j2u_1, tmp0_other_with_cast.j2u_1))
    return false;
  if (!(this.k2u_1 == tmp0_other_with_cast.k2u_1))
    return false;
  return true;
};
function Companion_0() {
}
protoOf(Companion_0).b2u = function (cause) {
  if (cause instanceof CancellationException)
    throw cause;
  var tmp0_elvis_lhs = cause instanceof SevenThrowable ? cause : null;
  return tmp0_elvis_lhs == null ? new Unknown(cause) : tmp0_elvis_lhs;
};
protoOf(Companion_0).l2u = function (cause) {
  return new Unknown(newThrowable(cause), cause);
};
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
function SevenThrowable() {
  extendThrowable(this);
  captureStack(this, SevenThrowable);
}
function IListLocalSource() {
}
function ILocalSource() {
}
function SessionBasedCache$get$slambda(this$0, $key, resultContinuation) {
  this.v2u_1 = this$0;
  this.w2u_1 = $key;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SessionBasedCache$get$slambda).b2v = function ($this$flow, $completion) {
  var tmp = this.c2v($this$flow, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(SessionBasedCache$get$slambda).h9 = function (p1, $completion) {
  return this.b2v((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(SessionBasedCache$get$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.y2u_1 = this.v2u_1.d2v_1;
          this.n8_1 = 1;
          suspendResult = getSessionBasedKey(this.v2u_1.e2v_1, this.w2u_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.z2u_1 = suspendResult;
          this.a2v_1 = this.y2u_1.h2a(this.z2u_1);
          this.n8_1 = 2;
          suspendResult = emitAll(this.x2u_1, this.a2v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SessionBasedCache$get$slambda).c2v = function ($this$flow, completion) {
  var i = new SessionBasedCache$get$slambda(this.v2u_1, this.w2u_1, completion);
  i.x2u_1 = $this$flow;
  return i;
};
function SessionBasedCache$get$slambda_0(this$0, $key, resultContinuation) {
  var i = new SessionBasedCache$get$slambda(this$0, $key, resultContinuation);
  var l = function ($this$flow, $completion) {
    return i.b2v($this$flow, $completion);
  };
  l.$arity = 1;
  return l;
}
function $putCOROUTINE$5(_this__u8e3s4, key, value, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n2v_1 = _this__u8e3s4;
  this.o2v_1 = key;
  this.p2v_1 = value;
}
protoOf($putCOROUTINE$5).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.q2v_1 = this.n2v_1.d2v_1;
          this.n8_1 = 1;
          suspendResult = getSessionBasedKey(this.n2v_1.e2v_1, this.o2v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.r2v_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.q2v_1.i2a(this.r2v_1, this.p2v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function SessionBasedCache(cache, sessionDataProvider, cacheCleanerRegistry) {
  cacheCleanerRegistry = cacheCleanerRegistry === VOID ? null : cacheCleanerRegistry;
  this.d2v_1 = cache;
  this.e2v_1 = sessionDataProvider;
  if (cacheCleanerRegistry == null)
    null;
  else
    cacheCleanerRegistry.g2a(this);
}
protoOf(SessionBasedCache).h2a = function (key) {
  return flow(SessionBasedCache$get$slambda_0(this, key, null));
};
protoOf(SessionBasedCache).i2a = function (key, value, $completion) {
  var tmp = new $putCOROUTINE$5(this, key, value, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function getSessionBasedKey(_this__u8e3s4, key, $completion) {
  var tmp = new $getSessionBasedKeyCOROUTINE$9(_this__u8e3s4, key, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function $getSessionBasedKeyCOROUTINE$9(_this__u8e3s4, key, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.a2w_1 = _this__u8e3s4;
  this.b2w_1 = key;
}
protoOf($getSessionBasedKeyCOROUTINE$9).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.a2w_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.c2w_1 = suspendResult;
          this.d2w_1 = this.c2w_1.toString();
          this.n8_1 = 2;
          suspendResult = this.a2w_1.f2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          var ARGUMENT = suspendResult;
          var ARGUMENT_0 = ARGUMENT.toString();
          return this.d2w_1 + '_' + ARGUMENT_0 + '_' + this.b2w_1;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function SimpleCacheLocalSource(key, cache) {
  this.g2w_1 = key;
  this.h2w_1 = cache;
}
protoOf(SimpleCacheLocalSource).n18 = function () {
  return this.h2w_1.h2a(this.g2w_1);
};
protoOf(SimpleCacheLocalSource).m2u = function (data, $completion) {
  return this.h2w_1.i2a(this.g2w_1, data, $completion);
};
function SimpleListCacheLocalSource(key, cache) {
  this.i2w_1 = key;
  this.j2w_1 = cache;
}
protoOf(SimpleListCacheLocalSource).n18 = function () {
  return this.j2w_1.h2a(this.i2w_1);
};
protoOf(SimpleListCacheLocalSource).k2w = function (data, $completion) {
  return this.j2w_1.i2a(this.i2w_1, data, $completion);
};
protoOf(SimpleListCacheLocalSource).m2u = function (data, $completion) {
  return this.k2w((!(data == null) ? isInterface(data, KtList) : false) ? data : THROW_CCE(), $completion);
};
function BaseCacheStrategy(localDataFlow, fetchData) {
  this.l2w_1 = localDataFlow;
  this.m2w_1 = fetchData;
}
function GetCacheStrategy$baseCacheStrategy$slambda(this$0, resultContinuation) {
  this.v2w_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(GetCacheStrategy$baseCacheStrategy$slambda).n2x = function ($this$BaseCacheStrategy, id, lastSeenData, $completion) {
  var tmp = this.o2x($this$BaseCacheStrategy, id, lastSeenData, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(GetCacheStrategy$baseCacheStrategy$slambda).p2x = function (p1, p2, p3, $completion) {
  var tmp = (!(p1 == null) ? isInterface(p1, DataStreamCollector) : false) ? p1 : THROW_CCE();
  var tmp_0 = !(p2 == null) ? p2 : THROW_CCE();
  return this.n2x(tmp, tmp_0, (p3 == null ? true : !(p3 == null)) ? p3 : THROW_CCE(), $completion);
};
protoOf(GetCacheStrategy$baseCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.n8_1 = 1;
          suspendResult = this.v2w_1.r2x_1(this.x2w_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.z2w_1 = suspendResult.ul_1;
          this.a2x_1 = this.z2w_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.a2x_1)) {
            var tmp_0 = this;
            var tmp_1 = _Result___get_value__impl__bjfvqg(this.a2x_1);
            tmp_0.b2x_1 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            this.c2x_1 = this.b2x_1;
            this.n8_1 = 2;
            suspendResult = this.v2w_1.s2x_1(this.v2w_1.t2x_1(this.c2x_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          suspendResult = this.w2w_1.v2x(this.v2w_1.t2x_1(this.c2x_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.d2x_1 = this.a2x_1;
          this.e2x_1 = this.d2x_1;
          this.f2x_1 = Result__exceptionOrNull_impl_p6xea9(this.e2x_1);
          if (this.f2x_1 == null) {
            this.g2x_1 = null;
            this.n8_1 = 6;
            continue $sm;
          } else {
            var tmp_2 = this;
            tmp_2.h2x_1 = this.f2x_1;
            this.i2x_1 = this.h2x_1;
            var tmp_3 = this;
            tmp_3.j2x_1 = this.i2x_1;
            this.k2x_1 = this.j2x_1;
            var tmp_4 = this;
            tmp_4.l2x_1 = this.k2x_1;
            this.m2x_1 = this.l2x_1;
            this.n8_1 = 5;
            suspendResult = this.w2w_1.w2x(Companion_instance_0.b2u(this.m2x_1), this.y2w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 5:
          var tmp_5 = this;
          tmp_5.g2x_1 = Unit_instance;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          return Unit_instance;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(GetCacheStrategy$baseCacheStrategy$slambda).o2x = function ($this$BaseCacheStrategy, id, lastSeenData, completion) {
  var i = new GetCacheStrategy$baseCacheStrategy$slambda(this.v2w_1, completion);
  i.w2w_1 = $this$BaseCacheStrategy;
  i.x2w_1 = id;
  i.y2w_1 = lastSeenData;
  return i;
};
function GetCacheStrategy$baseCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new GetCacheStrategy$baseCacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($this$BaseCacheStrategy, id, lastSeenData, $completion) {
    return i.n2x($this$BaseCacheStrategy, id, lastSeenData, $completion);
  };
  l.$arity = 3;
  return l;
}
function GetCacheStrategy(localDataFlow, fetchData, onNewData, mapData) {
  this.q2x_1 = localDataFlow;
  this.r2x_1 = fetchData;
  this.s2x_1 = onNewData;
  this.t2x_1 = mapData;
  var tmp = this;
  tmp.u2x_1 = new BaseCacheStrategy(this.q2x_1, GetCacheStrategy$baseCacheStrategy$slambda_0(this, null));
}
function GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda$lambda(this$0, $id) {
  return function (dataList) {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = dataList.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (equals(this$0.a2y_1(element), $id)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
}
function GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda($$this$unsafeFlow, this$0, $id, resultContinuation) {
  this.l2y_1 = $$this$unsafeFlow;
  this.m2y_1 = this$0;
  this.n2y_1 = $id;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda).y2a = function (value, $completion) {
  var tmp = this.z2a(value, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda).h9 = function (p1, $completion) {
  return this.y2a((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.p2y_1 = this.l2y_1;
          var tmp_1 = this;
          tmp_1.q2y_1 = this.o2y_1;
          this.r2y_1 = this.p2y_1;
          this.s2y_1 = this.q2y_1;
          this.n8_1 = 1;
          var data = this.s2y_1;
          suspendResult = this.r2y_1.b1z(emptyIfNull(data.t2b(GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda$lambda(this.m2y_1, this.n2y_1))), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda).z2a = function (value, completion) {
  var i = new GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda(this.l2y_1, this.m2y_1, this.n2y_1, completion);
  i.o2y_1 = value;
  return i;
};
function GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda_0($$this$unsafeFlow, this$0, $id, resultContinuation) {
  var i = new GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda($$this$unsafeFlow, this$0, $id, resultContinuation);
  var l = function (value, $completion) {
    return i.y2a(value, $completion);
  };
  l.$arity = 1;
  return l;
}
function $collectCOROUTINE$11(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b2z_1 = _this__u8e3s4;
  this.c2z_1 = collector;
}
protoOf($collectCOROUTINE$11).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.d2z_1 = this.c2z_1;
          this.e2z_1 = this.d2z_1;
          this.n8_1 = 1;
          var tmp_1 = GetFromListCacheStrategy$baseCacheStrategy$lambda$o$collect$slambda_0(this.e2z_1, this.b2z_1.g2z_1, this.b2z_1.h2z_1, null);
          suspendResult = this.b2z_1.f2z_1.h1y(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
  this.i2z_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).b1z = function (value, $completion) {
  return this.i2z_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).k3 = function () {
  return this.i2z_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.k3(), other.k3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
  return hashCode(this.k3());
};
function GetFromListCacheStrategy$baseCacheStrategy$1$$inlined$map$1($this, this$0, $id) {
  this.f2z_1 = $this;
  this.g2z_1 = this$0;
  this.h2z_1 = $id;
}
protoOf(GetFromListCacheStrategy$baseCacheStrategy$1$$inlined$map$1).c1z = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$11(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(GetFromListCacheStrategy$baseCacheStrategy$1$$inlined$map$1).h1y = function (collector, $completion) {
  return this.c1z(collector, $completion);
};
function GetFromListCacheStrategy$baseCacheStrategy$lambda(this$0) {
  return function (id) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this$0.x2x_1();
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new GetFromListCacheStrategy$baseCacheStrategy$1$$inlined$map$1(this_0, this$0, id);
  };
}
function GetFromListCacheStrategy$baseCacheStrategy$slambda(this$0, resultContinuation) {
  this.r2z_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(GetFromListCacheStrategy$baseCacheStrategy$slambda).r30 = function ($this$BaseCacheStrategy, id, lastSeenData, $completion) {
  var tmp = this.s30($this$BaseCacheStrategy, id, lastSeenData, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(GetFromListCacheStrategy$baseCacheStrategy$slambda).p2x = function (p1, p2, p3, $completion) {
  var tmp = (!(p1 == null) ? isInterface(p1, DataStreamCollector) : false) ? p1 : THROW_CCE();
  var tmp_0 = !(p2 == null) ? p2 : THROW_CCE();
  return this.r30(tmp, tmp_0, (p3 == null ? true : !(p3 == null)) ? p3 : THROW_CCE(), $completion);
};
protoOf(GetFromListCacheStrategy$baseCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 10;
          this.n8_1 = 1;
          suspendResult = this.r2z_1.y2x_1(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.v2z_1 = suspendResult.ul_1;
          this.w2z_1 = this.v2z_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.w2z_1)) {
            var tmp_0 = this;
            var tmp_1 = _Result___get_value__impl__bjfvqg(this.w2z_1);
            tmp_0.x2z_1 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            this.y2z_1 = this.x2z_1;
            var tmp_2 = this;
            var this_0 = this.y2z_1;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.j();
            while (_iterator__ex2g4s.k()) {
              var item = _iterator__ex2g4s.l();
              destination.e(this.r2z_1.b2y_1(item));
            }
            tmp_2.z2z_1 = destination;
            var tmp_3 = this;
            var tmp0 = this.z2z_1;
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              var _iterator__ex2g4s_0 = tmp0.j();
              while (_iterator__ex2g4s_0.k()) {
                var element = _iterator__ex2g4s_0.l();
                if (equals(this.r2z_1.a2y_1(element), this.t2z_1)) {
                  tmp$ret$0 = element;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = null;
            }
             while (false);
            tmp_3.a30_1 = tmp$ret$0;
            if (this.a30_1 == null) {
              this.b30_1 = null;
              this.n8_1 = 4;
              continue $sm;
            } else {
              var tmp_4 = this;
              tmp_4.c30_1 = this.a30_1;
              this.d30_1 = this.c30_1;
              var tmp_5 = this;
              tmp_5.e30_1 = this.d30_1;
              this.f30_1 = this.e30_1;
              this.n8_1 = 2;
              suspendResult = this.r2z_1.z2x_1(this.z2z_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            this.n8_1 = 7;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          suspendResult = this.s2z_1.v2x(this.f30_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          var tmp_6 = this;
          tmp_6.b30_1 = Unit_instance;
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.g30_1 = this.b30_1;
          if (this.g30_1 == null) {
            this.n8_1 = 5;
            suspendResult = this.s2z_1.t30(new NotFound(), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 6;
            continue $sm;
          }

        case 5:
          this.n8_1 = 6;
          continue $sm;
        case 6:
          this.n8_1 = 7;
          continue $sm;
        case 7:
          this.h30_1 = this.w2z_1;
          this.i30_1 = this.h30_1;
          this.j30_1 = Result__exceptionOrNull_impl_p6xea9(this.i30_1);
          if (this.j30_1 == null) {
            this.k30_1 = null;
            this.n8_1 = 9;
            continue $sm;
          } else {
            var tmp_7 = this;
            tmp_7.l30_1 = this.j30_1;
            this.m30_1 = this.l30_1;
            var tmp_8 = this;
            tmp_8.n30_1 = this.m30_1;
            this.o30_1 = this.n30_1;
            var tmp_9 = this;
            tmp_9.p30_1 = this.o30_1;
            this.q30_1 = this.p30_1;
            this.n8_1 = 8;
            suspendResult = this.s2z_1.w2x(Companion_instance_0.b2u(this.q30_1), this.u2z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 8:
          var tmp_10 = this;
          tmp_10.k30_1 = Unit_instance;
          this.n8_1 = 9;
          continue $sm;
        case 9:
          return Unit_instance;
        case 10:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 10) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(GetFromListCacheStrategy$baseCacheStrategy$slambda).s30 = function ($this$BaseCacheStrategy, id, lastSeenData, completion) {
  var i = new GetFromListCacheStrategy$baseCacheStrategy$slambda(this.r2z_1, completion);
  i.s2z_1 = $this$BaseCacheStrategy;
  i.t2z_1 = id;
  i.u2z_1 = lastSeenData;
  return i;
};
function GetFromListCacheStrategy$baseCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new GetFromListCacheStrategy$baseCacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($this$BaseCacheStrategy, id, lastSeenData, $completion) {
    return i.r30($this$BaseCacheStrategy, id, lastSeenData, $completion);
  };
  l.$arity = 3;
  return l;
}
function GetFromListCacheStrategy(localDataFlow, fetchData, onNewData, getDataId, mapData) {
  this.x2x_1 = localDataFlow;
  this.y2x_1 = fetchData;
  this.z2x_1 = onNewData;
  this.a2y_1 = getDataId;
  this.b2y_1 = mapData;
  var tmp = this;
  var tmp_0 = GetFromListCacheStrategy$baseCacheStrategy$lambda(this);
  tmp.c2y_1 = new BaseCacheStrategy(tmp_0, GetFromListCacheStrategy$baseCacheStrategy$slambda_0(this, null));
}
function ListCacheStrategy$baseCacheStrategy$slambda(this$0, resultContinuation) {
  this.c31_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ListCacheStrategy$baseCacheStrategy$slambda).u31 = function ($this$BaseCacheStrategy, query, lastSeenData, $completion) {
  var tmp = this.v31($this$BaseCacheStrategy, query, lastSeenData, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ListCacheStrategy$baseCacheStrategy$slambda).p2x = function (p1, p2, p3, $completion) {
  var tmp = (!(p1 == null) ? isInterface(p1, DataStreamCollector) : false) ? p1 : THROW_CCE();
  var tmp_0 = !(p2 == null) ? p2 : THROW_CCE();
  return this.u31(tmp, tmp_0, (p3 == null ? true : isInterface(p3, KtList)) ? p3 : THROW_CCE(), $completion);
};
protoOf(ListCacheStrategy$baseCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.n8_1 = 1;
          suspendResult = this.c31_1.x31_1(this.e31_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.g31_1 = suspendResult.ul_1;
          this.h31_1 = this.g31_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.h31_1)) {
            var tmp_0 = this;
            var tmp_1 = _Result___get_value__impl__bjfvqg(this.h31_1);
            tmp_0.i31_1 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            this.j31_1 = this.i31_1;
            this.n8_1 = 2;
            var this_0 = this.j31_1;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.j();
            while (_iterator__ex2g4s.k()) {
              var item = _iterator__ex2g4s.l();
              destination.e(this.c31_1.z31_1(item));
            }
            suspendResult = this.c31_1.y31_1(this.e31_1, destination, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          var this_1 = this.j31_1;
          var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_0 = this_1.j();
          while (_iterator__ex2g4s_0.k()) {
            var item_0 = _iterator__ex2g4s_0.l();
            destination_0.e(this.c31_1.z31_1(item_0));
          }

          suspendResult = this.d31_1.v2x(destination_0, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.k31_1 = this.h31_1;
          this.l31_1 = this.k31_1;
          this.m31_1 = Result__exceptionOrNull_impl_p6xea9(this.l31_1);
          if (this.m31_1 == null) {
            this.n31_1 = null;
            this.n8_1 = 6;
            continue $sm;
          } else {
            var tmp_2 = this;
            tmp_2.o31_1 = this.m31_1;
            this.p31_1 = this.o31_1;
            var tmp_3 = this;
            tmp_3.q31_1 = this.p31_1;
            this.r31_1 = this.q31_1;
            var tmp_4 = this;
            tmp_4.s31_1 = this.r31_1;
            this.t31_1 = this.s31_1;
            this.n8_1 = 5;
            suspendResult = this.d31_1.w2x(Companion_instance_0.b2u(this.t31_1), this.f31_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 5:
          var tmp_5 = this;
          tmp_5.n31_1 = Unit_instance;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          return Unit_instance;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(ListCacheStrategy$baseCacheStrategy$slambda).v31 = function ($this$BaseCacheStrategy, query, lastSeenData, completion) {
  var i = new ListCacheStrategy$baseCacheStrategy$slambda(this.c31_1, completion);
  i.d31_1 = $this$BaseCacheStrategy;
  i.e31_1 = query;
  i.f31_1 = lastSeenData;
  return i;
};
function ListCacheStrategy$baseCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new ListCacheStrategy$baseCacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($this$BaseCacheStrategy, query, lastSeenData, $completion) {
    return i.u31($this$BaseCacheStrategy, query, lastSeenData, $completion);
  };
  l.$arity = 3;
  return l;
}
function ListCacheStrategy(localDataFlow, fetchData, onNewData, mapData) {
  this.w31_1 = localDataFlow;
  this.x31_1 = fetchData;
  this.y31_1 = onNewData;
  this.z31_1 = mapData;
  var tmp = this;
  tmp.a32_1 = new BaseCacheStrategy(this.w31_1, ListCacheStrategy$baseCacheStrategy$slambda_0(this, null));
}
function QueryListEndpointCacheStrategy$getStrategy$lambda($localDataFlow) {
  return function () {
    return $localDataFlow;
  };
}
function QueryListEndpointCacheStrategy$getStrategy$slambda($fetchData, $defaultQuery, resultContinuation) {
  this.j32_1 = $fetchData;
  this.k32_1 = $defaultQuery;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(QueryListEndpointCacheStrategy$getStrategy$slambda).l32 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(QueryListEndpointCacheStrategy$getStrategy$slambda).ma = function ($completion) {
  return this.l32($completion);
};
protoOf(QueryListEndpointCacheStrategy$getStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.j32_1(this.k32_1(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(QueryListEndpointCacheStrategy$getStrategy$slambda).m32 = function (completion) {
  return new QueryListEndpointCacheStrategy$getStrategy$slambda(this.j32_1, this.k32_1, completion);
};
function QueryListEndpointCacheStrategy$getStrategy$slambda_0($fetchData, $defaultQuery, resultContinuation) {
  var i = new QueryListEndpointCacheStrategy$getStrategy$slambda($fetchData, $defaultQuery, resultContinuation);
  var l = function ($completion) {
    return i.l32($completion);
  };
  l.$arity = 0;
  return l;
}
function QueryListEndpointCacheStrategy$getStrategy$slambda_1($onNewData, $defaultQuery, resultContinuation) {
  this.v32_1 = $onNewData;
  this.w32_1 = $defaultQuery;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(QueryListEndpointCacheStrategy$getStrategy$slambda_1).y32 = function (it, $completion) {
  var tmp = this.z32(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(QueryListEndpointCacheStrategy$getStrategy$slambda_1).h9 = function (p1, $completion) {
  return this.y32((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(QueryListEndpointCacheStrategy$getStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.v32_1(this.w32_1(), this.x32_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(QueryListEndpointCacheStrategy$getStrategy$slambda_1).z32 = function (it, completion) {
  var i = new QueryListEndpointCacheStrategy$getStrategy$slambda_1(this.v32_1, this.w32_1, completion);
  i.x32_1 = it;
  return i;
};
function QueryListEndpointCacheStrategy$getStrategy$slambda_2($onNewData, $defaultQuery, resultContinuation) {
  var i = new QueryListEndpointCacheStrategy$getStrategy$slambda_1($onNewData, $defaultQuery, resultContinuation);
  var l = function (it, $completion) {
    return i.y32(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function QueryListEndpointCacheStrategy$listStrategy$lambda($localDataFlow) {
  return function (it) {
    return $localDataFlow;
  };
}
function QueryListEndpointCacheStrategy(localDataFlow, onNewData, fetchData, defaultQuery, mapData, getDataId) {
  var tmp = this;
  var tmp_0 = QueryListEndpointCacheStrategy$getStrategy$lambda(localDataFlow);
  var tmp_1 = QueryListEndpointCacheStrategy$getStrategy$slambda_0(fetchData, defaultQuery, null);
  tmp.a33_1 = new GetFromListCacheStrategy(tmp_0, tmp_1, QueryListEndpointCacheStrategy$getStrategy$slambda_2(onNewData, defaultQuery, null), getDataId, mapData);
  var tmp_2 = this;
  tmp_2.b33_1 = new ListCacheStrategy(QueryListEndpointCacheStrategy$listStrategy$lambda(localDataFlow), fetchData, onNewData, mapData);
}
function SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda$lambda(this$0, $id) {
  return function (list) {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = list.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (equals(this$0.f33_1(element), $id)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
}
function SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda($$this$unsafeFlow, this$0, $id, resultContinuation) {
  this.q33_1 = $$this$unsafeFlow;
  this.r33_1 = this$0;
  this.s33_1 = $id;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda).y2a = function (value, $completion) {
  var tmp = this.z2a(value, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda).h9 = function (p1, $completion) {
  return this.y2a((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.u33_1 = this.q33_1;
          var tmp_1 = this;
          tmp_1.v33_1 = this.t33_1;
          this.w33_1 = this.u33_1;
          this.x33_1 = this.v33_1;
          this.n8_1 = 1;
          var cacheData = this.x33_1;
          suspendResult = this.w33_1.b1z(emptyIfNull(cacheData.t2b(SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda$lambda(this.r33_1, this.s33_1))), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda).z2a = function (value, completion) {
  var i = new SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda(this.q33_1, this.r33_1, this.s33_1, completion);
  i.t33_1 = value;
  return i;
};
function SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda_0($$this$unsafeFlow, this$0, $id, resultContinuation) {
  var i = new SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda($$this$unsafeFlow, this$0, $id, resultContinuation);
  var l = function (value, $completion) {
    return i.y2a(value, $completion);
  };
  l.$arity = 1;
  return l;
}
function $collectCOROUTINE$12(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g34_1 = _this__u8e3s4;
  this.h34_1 = collector;
}
protoOf($collectCOROUTINE$12).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.i34_1 = this.h34_1;
          this.j34_1 = this.i34_1;
          this.n8_1 = 1;
          var tmp_1 = SimpleGetEndpointCacheStrategy$strategy$lambda$o$collect$slambda_0(this.j34_1, this.g34_1.l34_1, this.g34_1.m34_1, null);
          suspendResult = this.g34_1.k34_1.h1y(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
  this.n34_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).b1z = function (value, $completion) {
  return this.n34_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).k3 = function () {
  return this.n34_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.k3(), other.k3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
  return hashCode(this.k3());
};
function SimpleGetEndpointCacheStrategy$strategy$1$$inlined$map$1($this, this$0, $id) {
  this.k34_1 = $this;
  this.l34_1 = this$0;
  this.m34_1 = $id;
}
protoOf(SimpleGetEndpointCacheStrategy$strategy$1$$inlined$map$1).c1z = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$12(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(SimpleGetEndpointCacheStrategy$strategy$1$$inlined$map$1).h1y = function (collector, $completion) {
  return this.c1z(collector, $completion);
};
function SimpleGetEndpointCacheStrategy$strategy$lambda(this$0) {
  return function (id) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this$0.c33_1.n18();
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new SimpleGetEndpointCacheStrategy$strategy$1$$inlined$map$1(this_0, this$0, id);
  };
}
function SimpleGetEndpointCacheStrategy$strategy$slambda(this$0, resultContinuation) {
  this.w34_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SimpleGetEndpointCacheStrategy$strategy$slambda).f35 = function (item, $completion) {
  var tmp = this.g35(item, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(SimpleGetEndpointCacheStrategy$strategy$slambda).h9 = function (p1, $completion) {
  return this.f35(!(p1 == null) ? p1 : THROW_CCE(), $completion);
};
protoOf(SimpleGetEndpointCacheStrategy$strategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          var tmp_0 = this;
          tmp_0.y34_1 = this.w34_1.g33_1;
          this.z34_1 = this.y34_1;
          var tmp_1 = this;
          tmp_1.a35_1 = null;
          this.n8_1 = 1;
          suspendResult = this.z34_1.y27(this.a35_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.b35_1 = Unit_instance;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.o8_1 = 6;
          this.n8_1 = 3;
          suspendResult = firstOrNull(this.w34_1.c33_1.n18(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.c35_1 = suspendResult;
          this.d35_1 = this.c35_1 == null ? null : this.c35_1.s2b();
          this.e35_1 = this.d35_1 == null ? emptyList() : this.d35_1;
          this.n8_1 = 4;
          var tmp0 = this.e35_1;
          var destination = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s = tmp0.j();
          while (_iterator__ex2g4s.k()) {
            var element = _iterator__ex2g4s.l();
            if (!equals(this.w34_1.f33_1(element), this.w34_1.f33_1(this.x34_1))) {
              destination.e(element);
            }
          }

          suspendResult = this.w34_1.c33_1.m2u(plus(destination, this.x34_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.b35_1 = Unit_instance;
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 5:
          this.b35_1;
          this.o8_1 = 7;
          this.z34_1.k27(this.a35_1);
          return Unit_instance;
        case 6:
          this.o8_1 = 7;
          var t = this.q8_1;
          this.z34_1.k27(this.a35_1);
          throw t;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SimpleGetEndpointCacheStrategy$strategy$slambda).g35 = function (item, completion) {
  var i = new SimpleGetEndpointCacheStrategy$strategy$slambda(this.w34_1, completion);
  i.x34_1 = item;
  return i;
};
function SimpleGetEndpointCacheStrategy$strategy$slambda_0(this$0, resultContinuation) {
  var i = new SimpleGetEndpointCacheStrategy$strategy$slambda(this$0, resultContinuation);
  var l = function (item, $completion) {
    return i.f35(item, $completion);
  };
  l.$arity = 1;
  return l;
}
function SimpleGetEndpointCacheStrategy(localSource, fetchData, mapData, getDataId) {
  this.c33_1 = localSource;
  this.d33_1 = fetchData;
  this.e33_1 = mapData;
  this.f33_1 = getDataId;
  this.g33_1 = Mutex();
  var tmp = this;
  var tmp_0 = SimpleGetEndpointCacheStrategy$strategy$lambda(this);
  tmp.h33_1 = new GetCacheStrategy(tmp_0, this.d33_1, SimpleGetEndpointCacheStrategy$strategy$slambda_0(this, null), this.e33_1);
}
function SimpleListEndpointCacheStrategy$getStrategy$lambda($localDataFlow) {
  return function () {
    return $localDataFlow;
  };
}
function SimpleListEndpointCacheStrategy$getStrategy$slambda($fetchData, resultContinuation) {
  this.p35_1 = $fetchData;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SimpleListEndpointCacheStrategy$getStrategy$slambda).l32 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(SimpleListEndpointCacheStrategy$getStrategy$slambda).ma = function ($completion) {
  return this.l32($completion);
};
protoOf(SimpleListEndpointCacheStrategy$getStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.p35_1(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SimpleListEndpointCacheStrategy$getStrategy$slambda).m32 = function (completion) {
  return new SimpleListEndpointCacheStrategy$getStrategy$slambda(this.p35_1, completion);
};
function SimpleListEndpointCacheStrategy$getStrategy$slambda_0($fetchData, resultContinuation) {
  var i = new SimpleListEndpointCacheStrategy$getStrategy$slambda($fetchData, resultContinuation);
  var l = function ($completion) {
    return i.l32($completion);
  };
  l.$arity = 0;
  return l;
}
function SimpleListEndpointCacheStrategy$listStrategy$lambda($localDataFlow) {
  return function (it) {
    return $localDataFlow;
  };
}
function SimpleListEndpointCacheStrategy$listStrategy$slambda($fetchData, resultContinuation) {
  this.y35_1 = $fetchData;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SimpleListEndpointCacheStrategy$listStrategy$slambda).a36 = function (it, $completion) {
  var tmp = this.b36(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(SimpleListEndpointCacheStrategy$listStrategy$slambda).h9 = function (p1, $completion) {
  return this.a36(p1 instanceof Unit ? p1 : THROW_CCE(), $completion);
};
protoOf(SimpleListEndpointCacheStrategy$listStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.y35_1(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SimpleListEndpointCacheStrategy$listStrategy$slambda).b36 = function (it, completion) {
  var i = new SimpleListEndpointCacheStrategy$listStrategy$slambda(this.y35_1, completion);
  i.z35_1 = it;
  return i;
};
function SimpleListEndpointCacheStrategy$listStrategy$slambda_0($fetchData, resultContinuation) {
  var i = new SimpleListEndpointCacheStrategy$listStrategy$slambda($fetchData, resultContinuation);
  var l = function (it, $completion) {
    return i.a36(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function SimpleListEndpointCacheStrategy$listStrategy$slambda_1($onNewData, resultContinuation) {
  this.k36_1 = $onNewData;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SimpleListEndpointCacheStrategy$listStrategy$slambda_1).n36 = function (_unused_var__etf5q3, data, $completion) {
  var tmp = this.o36(_unused_var__etf5q3, data, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(SimpleListEndpointCacheStrategy$listStrategy$slambda_1).i9 = function (p1, p2, $completion) {
  var tmp = p1 instanceof Unit ? p1 : THROW_CCE();
  return this.n36(tmp, (!(p2 == null) ? isInterface(p2, KtList) : false) ? p2 : THROW_CCE(), $completion);
};
protoOf(SimpleListEndpointCacheStrategy$listStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.k36_1(this.m36_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SimpleListEndpointCacheStrategy$listStrategy$slambda_1).o36 = function (_unused_var__etf5q3, data, completion) {
  var i = new SimpleListEndpointCacheStrategy$listStrategy$slambda_1(this.k36_1, completion);
  i.l36_1 = _unused_var__etf5q3;
  i.m36_1 = data;
  return i;
};
function SimpleListEndpointCacheStrategy$listStrategy$slambda_2($onNewData, resultContinuation) {
  var i = new SimpleListEndpointCacheStrategy$listStrategy$slambda_1($onNewData, resultContinuation);
  var l = function (_unused_var__etf5q3, data, $completion) {
    return i.n36(_unused_var__etf5q3, data, $completion);
  };
  l.$arity = 2;
  return l;
}
function SimpleListEndpointCacheStrategy(localDataFlow, onNewData, fetchData, mapData, getDataId) {
  var tmp = this;
  var tmp_0 = SimpleListEndpointCacheStrategy$getStrategy$lambda(localDataFlow);
  tmp.p36_1 = new GetFromListCacheStrategy(tmp_0, SimpleListEndpointCacheStrategy$getStrategy$slambda_0(fetchData, null), onNewData, getDataId, mapData);
  var tmp_1 = this;
  var tmp_2 = SimpleListEndpointCacheStrategy$listStrategy$lambda(localDataFlow);
  var tmp_3 = SimpleListEndpointCacheStrategy$listStrategy$slambda_0(fetchData, null);
  tmp_1.q36_1 = new ListCacheStrategy(tmp_2, tmp_3, SimpleListEndpointCacheStrategy$listStrategy$slambda_2(onNewData, null), mapData);
}
function SimpleValueEndpointCacheStrategy$baseStrategy$lambda($localDataFlow) {
  return function (it) {
    return $localDataFlow;
  };
}
function SimpleValueEndpointCacheStrategy$baseStrategy$slambda($fetchData, resultContinuation) {
  this.z36_1 = $fetchData;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SimpleValueEndpointCacheStrategy$baseStrategy$slambda).b37 = function (it, $completion) {
  var tmp = this.b36(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(SimpleValueEndpointCacheStrategy$baseStrategy$slambda).h9 = function (p1, $completion) {
  return this.b37(p1 instanceof Unit ? p1 : THROW_CCE(), $completion);
};
protoOf(SimpleValueEndpointCacheStrategy$baseStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.z36_1(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SimpleValueEndpointCacheStrategy$baseStrategy$slambda).b36 = function (it, completion) {
  var i = new SimpleValueEndpointCacheStrategy$baseStrategy$slambda(this.z36_1, completion);
  i.a37_1 = it;
  return i;
};
function SimpleValueEndpointCacheStrategy$baseStrategy$slambda_0($fetchData, resultContinuation) {
  var i = new SimpleValueEndpointCacheStrategy$baseStrategy$slambda($fetchData, resultContinuation);
  var l = function (it, $completion) {
    return i.b37(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function SimpleValueEndpointCacheStrategy(localDataFlow, onNewData, fetchData, mapData) {
  var tmp = this;
  var tmp_0 = SimpleValueEndpointCacheStrategy$baseStrategy$lambda(localDataFlow);
  tmp.c37_1 = new GetCacheStrategy(tmp_0, SimpleValueEndpointCacheStrategy$baseStrategy$slambda_0(fetchData, null), onNewData, mapData);
}
function DataStreamCollector() {
}
function DateTimeProvider() {
}
protoOf(DateTimeProvider).d37 = function (timeZone) {
  return toLocalDateTime(this.e37(), timeZone);
};
protoOf(DateTimeProvider).f37 = function (timeZone) {
  return this.d37(timeZone).w2k();
};
protoOf(DateTimeProvider).e37 = function () {
  return System_instance.w2b();
};
function IDateTimeProvider() {
}
function get_baseModule() {
  _init_properties_BaseModule_kt__q6ewhp();
  return baseModule;
}
var baseModule;
function baseModule$lambda($this$module) {
  _init_properties_BaseModule_kt__q6ewhp();
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = baseModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance_0().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(CacheCleanerRegistry), null, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  var tmp = new KoinDefinition($this$module, factory);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [getKClass(ICacheCleaner)];
  binds(tmp, tmp$ret$5);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = baseModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance_0().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(ICache), null, tmp2, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = baseModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance_0().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IDateTimeProvider), null, tmp2_0, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  return Unit_instance;
}
function baseModule$lambda$lambda($this$single, it) {
  _init_properties_BaseModule_kt__q6ewhp();
  return new CacheCleanerRegistry();
}
function baseModule$lambda$lambda_0($this$factory, it) {
  _init_properties_BaseModule_kt__q6ewhp();
  var tmp = new InMemoryCache();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(CacheCleanerRegistry), null, null);
  return new SessionBasedCache(tmp, tmp_0, tmp$ret$1);
}
function baseModule$lambda$lambda_1($this$factory, it) {
  _init_properties_BaseModule_kt__q6ewhp();
  return new DateTimeProvider();
}
var properties_initialized_BaseModule_kt_i0t0e9;
function _init_properties_BaseModule_kt__q6ewhp() {
  if (!properties_initialized_BaseModule_kt_i0t0e9) {
    properties_initialized_BaseModule_kt_i0t0e9 = true;
    baseModule = module_0(VOID, baseModule$lambda);
  }
}
function AppLifecycleProvider() {
  this.h37_1 = MutableStateFlow(AppLifecycleState_FOREGROUND_getInstance());
  this.i37_1 = asStateFlow(this.h37_1);
}
protoOf(AppLifecycleProvider).j37 = function () {
  return this.i37_1;
};
function IAppLifecycleProvider() {
}
var AppLifecycleState_FOREGROUND_instance;
var AppLifecycleState_BACKGROUND_instance;
var AppLifecycleState_entriesInitialized;
function AppLifecycleState_initEntries() {
  if (AppLifecycleState_entriesInitialized)
    return Unit_instance;
  AppLifecycleState_entriesInitialized = true;
  AppLifecycleState_FOREGROUND_instance = new AppLifecycleState('FOREGROUND', 0);
  AppLifecycleState_BACKGROUND_instance = new AppLifecycleState('BACKGROUND', 1);
}
function AppLifecycleState(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function AppLifecycleState_FOREGROUND_getInstance() {
  AppLifecycleState_initEntries();
  return AppLifecycleState_FOREGROUND_instance;
}
function IEnvironmentProvider() {
}
var Platform_IOS_instance;
var Platform_ANDROID_instance;
var Platform_WEB_instance;
var Platform_entriesInitialized;
function Platform_initEntries() {
  if (Platform_entriesInitialized)
    return Unit_instance;
  Platform_entriesInitialized = true;
  Platform_IOS_instance = new Platform('IOS', 0);
  Platform_ANDROID_instance = new Platform('ANDROID', 1);
  Platform_WEB_instance = new Platform('WEB', 2);
}
function Platform(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Platform_WEB_getInstance() {
  Platform_initEntries();
  return Platform_WEB_instance;
}
function INetworkReachabilityProvider() {
}
var NetworkReachabilityState_CONNECTED_instance;
var NetworkReachabilityState_DISCONNECTED_instance;
var NetworkReachabilityState_entriesInitialized;
function NetworkReachabilityState_initEntries() {
  if (NetworkReachabilityState_entriesInitialized)
    return Unit_instance;
  NetworkReachabilityState_entriesInitialized = true;
  NetworkReachabilityState_CONNECTED_instance = new NetworkReachabilityState('CONNECTED', 0);
  NetworkReachabilityState_DISCONNECTED_instance = new NetworkReachabilityState('DISCONNECTED', 1);
}
function NetworkReachabilityState(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function NetworkReachabilityState_CONNECTED_getInstance() {
  NetworkReachabilityState_initEntries();
  return NetworkReachabilityState_CONNECTED_instance;
}
function ISessionDataProvider() {
}
function NetworkReachabilityProvider() {
  this.r37_1 = MutableStateFlow(NetworkReachabilityState_CONNECTED_getInstance());
  this.s37_1 = asStateFlow(this.r37_1);
}
protoOf(NetworkReachabilityProvider).j37 = function () {
  return this.s37_1;
};
//region block: post-declaration
defineProp(protoOf(Unknown), 'cause', function () {
  return this.h1();
});
defineProp(protoOf(Unknown), 'message', function () {
  return this.g1();
});
defineProp(protoOf(BadRequest), 'message', function () {
  return this.g1();
});
defineProp(protoOf(Unauthorized), 'message', function () {
  return this.g1();
});
defineProp(protoOf(Forbidden), 'message', function () {
  return this.g1();
});
defineProp(protoOf(NotFound), 'message', function () {
  return this.g1();
});
defineProp(protoOf(Conflict), 'message', function () {
  return this.g1();
});
defineProp(protoOf(UnexpectedApiResponse), 'cause', function () {
  return this.h1();
});
defineProp(protoOf(UnexpectedApiResponse), 'message', function () {
  return this.g1();
});
protoOf(DateTimeProvider).g37 = getCurrentDate$default;
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
//endregion
//region block: exports
export {
  QueryListEndpointCacheStrategy as QueryListEndpointCacheStrategy1c0c59lgyft8l,
  SimpleGetEndpointCacheStrategy as SimpleGetEndpointCacheStrategy39ps4f500p69k,
  SimpleListEndpointCacheStrategy as SimpleListEndpointCacheStrategy1m0xsspwu4sws,
  SimpleValueEndpointCacheStrategy as SimpleValueEndpointCacheStrategy2snxed6lorji8,
  IListLocalSource as IListLocalSource39ga4nlfbxuv1,
  ILocalSource as ILocalSource1zuymxsgjvvss,
  SessionBasedCache as SessionBasedCache2ygh1ov6l3auc,
  SimpleCacheLocalSource as SimpleCacheLocalSource3mbicvk11uh40,
  SimpleListCacheLocalSource as SimpleListCacheLocalSource9ig3nhg8ocnr,
  IDateTimeProvider as IDateTimeProvider3dxwb1v3szpn5,
  get_baseModule as get_baseModuleslmsxkf2lho3,
  AppLifecycleProvider as AppLifecycleProviderzypty41ik3ni,
  AppLifecycleState as AppLifecycleState1haxglbr7tfw1,
  IAppLifecycleProvider as IAppLifecycleProvider24td8xdm5ip99,
  IEnvironmentProvider as IEnvironmentProvider2spq4fpbokmem,
  INetworkReachabilityProvider as INetworkReachabilityProvider3jgigvmyn5cvt,
  ISessionDataProvider as ISessionDataProvidercfh7rhcdvasx,
  NetworkReachabilityProvider as NetworkReachabilityProviderbbozaiyk4yhb,
  NetworkReachabilityState as NetworkReachabilityState2q9jru8wd0cgm,
  Failure as Failurenhl40niycb88,
  Success as Success12c9v3ji39tsw,
  BadRequest as BadRequest1sf43sgrco9q2,
  Conflict as Conflict1e0yfippryym4,
  Forbidden as Forbidden31h9i07nwe7so,
  NotFound as NotFoundzza6y93k8gbh,
  Unauthorized as Unauthorized2vw47nfko1hfy,
  UnexpectedApiResponse as UnexpectedApiResponse11rd45rhjxm6r,
  Unknown as Unknown1xcq5nwq6ckcn,
  SevenThrowable as SevenThrowable22svzb6i8gddd,
  toSevenResult as toSevenResult26rf3ex1jyb3l,
  AppLifecycleState_FOREGROUND_getInstance as AppLifecycleState_FOREGROUND_getInstance37mlw95p8wl1x,
  NetworkReachabilityState_CONNECTED_getInstance as NetworkReachabilityState_CONNECTED_getInstanceklfxsi7jyjzd,
  Platform_WEB_getInstance as Platform_WEB_getInstance2zw09fslhbpz8,
  Companion_instance as Companion_instance2llo3g7f0d1n5,
  Companion_instance_0 as Companion_instance38at02i5wbrbj,
};
//endregion

